<ngx-slick-carousel class="carousel directors-carousel" 
                        #slickModal="slick-carousel" 
                        [config]="slideConfig">
        <div ngxSlickItem class="item slide" *ngFor="let leader of leaders">
            <a [routerLink]="[leader.leader_slug]" target="_blank"> 
                <div class="card red-card profile-card">
                <div class="card-img-wrapper">
                    <img [src]="leader.banner_image" alt="" class="card-img-top">                 
                </div>
                <div class="card-body">
                    <h4 class="profile-name">{{leader.leader_name}}</h4>
                    <p class="designation">{{leader.leader_position}} </p>
                </div>
            </div>
        </a>
        </div>
    
    </ngx-slick-carousel>